import { useEffect } from "react";
import { Config } from "src/config";
import HttpServices from "src/services/httpService";
import { integrateModuleURL } from "src/services/urlService";
import { useState } from "react";
import { useToaster } from "src/utils/toaster/toasterContext";
import { CommonHelper } from "src/utils/commonHelper";
import CustomDomainRedirectIframe from '../customDomainIframe';
import SnapchatAuthorizationModal from "../snapchatIntegration/SnapchatAuthorizationModal";

const SnapChatReAuthenticate = ({ AccountId, handleClose, getConnectedNetworks }) => {
  const [isAuthorizationModalOpen, setAuthorizationModal] = useState(true);
  const { showToast } = useToaster();
  const isCustomDomain = CommonHelper.CustomDomain();

  let isProcessing = false;
  let intervalId = null;

  useEffect(() => {
    intervalId = setInterval(() => {
      checkAccessTokenReceivedFromSnapchat();
    }, Config.Common.socialAccountsIntegrationInterval);
    return () => {
      clearInterval(intervalId);
    };
  }, [])

  const getSnapchatOauthToken = () => {
     window.open(
      `${Config.Snapchat.authorizeUrl}?client_id=${Config.Snapchat.clientId}&scope=${Config.Snapchat.scope}&redirect_uri=${Config.Snapchat.redirectUri}&response_type=code`
    );
}

  const checkAccessTokenReceivedFromSnapchat = () => {
      if (isCustomDomain) {
        const handleMessage = (event) => {
          const { type, code } = event.data;
          if (type === "snapchat_code" && code && !isProcessing) {
            isProcessing = true
            window.removeEventListener("message", handleMessage, false); // Remove event listener
            clearInterval(intervalId); // Stop polling
            sendAccessTokenToServer(code); // Process the code
          }
        };

        window.addEventListener("message", handleMessage, false);
      } else {
        var code = localStorage.getItem("snapchat_code");
        var error = localStorage.getItem("snapchat_error");
        if (code) {
          localStorage.removeItem("snapchat_code");
          clearInterval(intervalId);
          sendAccessTokenToServer(code);
        }
        else if (error) {
          localStorage.removeItem("snapchat_error");
          clearInterval(intervalId);
          showToast(error, 'e');
        }
      }
    };
    const snapchatSuccessCallback = (data, message) => {
      showToast(message, 's');
      getConnectedNetworks();
      handleClose();
    }
    const snapchatFailureCallback = (message) => {
      showToast(message, 'e');
      handleClose();
    }
    const sendAccessTokenToServer = (code) => {
      let snapchatForm = {
        code,
        account_id: AccountId
      };
      let postProps = {
        url: integrateModuleURL.reAuthenticateSnapChat,
        body: snapchatForm,
        successCallback: snapchatSuccessCallback,
        failureCallback: snapchatFailureCallback
      }
      HttpServices.Post(postProps);
    };

    return (
      <>{isAuthorizationModalOpen &&
        <SnapchatAuthorizationModal
          handleConnectSnapchat={getSnapchatOauthToken}
          handleClose={handleClose}
          reAuth={true}
        />}{isCustomDomain && <CustomDomainRedirectIframe serviceName="snapchat" />}</>
    );
  };
  export default SnapChatReAuthenticate;